import {FilterListForm} from 'common/pages/filter-list/FilterListForm'

export const FilterListFormAdv = (props) =>
    <FilterListForm {...props} mode={props.mode} admin={false} />